import createSvgIcon from '../Utils/CreateSvgIcon';

export const BodyColorGrey = createSvgIcon(
  <circle cx="10" cy="10" fill="#838383" r="10" transform="matrix(1 0 0 -1 2 22)" />,
  'BodyColorGrey',
);
